import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";
import {buildQueryString} from "../../utils/buildQueryString";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getAllEnquiry = createAsyncThunk(
  "enquiryLog/getAllEnquiry",
  async (obj, {rejectWithValue}) => {
    // debugger;
    try {
      let queryString = buildQueryString(obj);

      const res = await api.get(
        `${WiseBerryAPIEnv}enquiry?${queryString}&limit=10`
      );
      return res.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const getAllContactNote = createAsyncThunk(
  "enquiryLog/getAllContactNote",
  async (id, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}contact/notes?contact=${id}`
      );
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);
export const pinnedNote = createAsyncThunk(
  "enquiryLog/pinnedNote",
  async ({data, id}, {rejectWithValue}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}note/${id}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

// pinned: 1
// _method: PATCH
// https://uat.wiseberryonline.com.au/api/v1/note/19208445

export const UpdateEnquiry = createAsyncThunk(
  "enquiryLog/UpdateEnquiry",
  async ({data, id}, {rejectWithValue}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}enquiry/${id}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const completeLog = createAsyncThunk(
  "enquiryLog/completeLog",
  async (id, {rejectWithValue}) => {
    try {
      const payload = {selected_ids: [id]};

      const res = await api.post(
        `${WiseBerryAPIEnv}enquiry/bulk-complete`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (
        res.data.message === "Enquiries have been marked complete successfully"
      ) {
        return id;
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  }
);

let initialState = {
  enquiryLog: {},
  enquiryLogError: null,
  loading: false,

  contactNotes: [],
  contactNotesError: null,
  loadingNotes: false,

  updateEnquiry: {},
  loadingEnquire: false,
  updateEnquiryError: null,

  completed: null,
  completedError: null,
  completedLoading: false,

  pinned: null,
  pinnedError: null,
  loadingPinned: false,
};

const EnquiryLog = createSlice({
  name: "enquiryLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllEnquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllEnquiry.fulfilled, (state, action) => {
        if (action.payload.current_page === 1) {
          state.enquiryLog = action.payload;
        } else {
          state.enquiryLog.data = [
            ...state.enquiryLog.data,
            ...action.payload.data,
          ];
          state.enquiryLog.current_page = action.payload.current_page;
        }
        state.loading = false;
        state.enquiryLogError = null;
      })
      .addCase(getAllEnquiry.rejected, (state, action) => {
        state.loading = false;
        state.enquiryLogError = action.payload;
        state.enquiryLog = {};
      })
      .addCase(getAllContactNote.pending, (state) => {
        state.loadingNotes = true;
      })
      .addCase(getAllContactNote.fulfilled, (state, action) => {
        state.loadingNotes = false;
        state.contactNotes = action.payload;
        state.contactNotesError = null;
      })
      .addCase(getAllContactNote.rejected, (state, action) => {
        state.loadingNotes = false;
        state.contactNotesError = action.payload;
        state.contactNotes = [];
      })
      .addCase(UpdateEnquiry.pending, (state) => {
        state.loadingEnquire = true;
      })
      .addCase(UpdateEnquiry.fulfilled, (state, action) => {
        state.loadingEnquire = false;
        state.updateEnquiry = action.payload;
        state.updateEnquiryError = null;
        state.enquiryLog = state.enquiryLog.data.filter((enquiry) => {
          return enquiry.id !== action.payload;
        });
      })
      .addCase(UpdateEnquiry.rejected, (state, action) => {
        state.loadingEnquire = false;
        state.updateEnquiryError = action.payload;
        state.updateEnquiry = [];
      })
      .addCase(completeLog.pending, (state) => {
        state.completedLoading = true;
      })
      .addCase(completeLog.fulfilled, (state, action) => {
        state.completedLoading = false;
        state.completed = action.payload;
        state.completedError = null;
      })
      .addCase(completeLog.rejected, (state, action) => {
        state.completedLoading = false;
        state.completedError = action.payload;
        state.completed = null;
      })
      .addCase(pinnedNote.pending, (state) => {
        state.loadingPinned = true;
      })
      .addCase(pinnedNote.fulfilled, (state, action) => {
        state.loadingPinned = false;
        state.pinned = action.payload;
        state.pinnedError = null;
      })
      .addCase(pinnedNote.rejected, (state, action) => {
        state.loadingPinned = false;
        state.pinnedError = action.payload;
        state.pinned = [];
      });

    // .addCase(logout?.fulfilled, (state, action) => {
    //   // Update state with data from the rejected action
    //   return initialState;
    // });
  },
});

export default EnquiryLog.reducer;
